export enum SortType {
  Asc = 'Asc',
  Desc = 'Desc',
}
